import {
  filter_all,
  filter_last_30_days,
  filter_last_month,
  filter_last_week,
  filter_this_month,
  filter_this_week,
  filter_today,
  filter_yesterday,
} from '../../../../../components/filters/DateRangePicker';

export default {
  filters: {
    [filter_today]: 'Heute',
    [filter_yesterday]: 'Gestern',
    [filter_this_week]: 'Diese Woche',
    [filter_last_week]: 'Letzte Woche',
    [filter_this_month]: 'Diesen Monat',
    [filter_last_month]: 'Letzter Monat',
    [filter_last_30_days]: 'Letzter 30 Tage',
    [filter_all]: 'Alle',
  },
};
